import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();

const base = '/api/v1/visitor-users';

export default {
  getUser(userId) {
    return axios.get(`${base}/user/${userId}`);
  },
  getUsersWithContactInPrison(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/have-contact-in-prison/paginated${queryString}`);
  },
};
